"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("../../authenticated.client");
const settings_1 = require("../../../settings");
class BrandClient extends authenticated_client_1.AuthenticatedClient {
    constructor(settings = settings_1.DefaultClientSettings) {
        super(settings);
        this.settings = settings;
        this.executor.setFormatDateWithTimezone(true);
    }
    getAll(projectId, catalogId, search) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/catalogs/${catalogId}/brands?${this.getQueryString(search)}`);
            return response.payload || [];
        });
    }
    search(projectId, catalogId, request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/catalogs/${catalogId}/brands${newService ? '?newService=true' : ''}`, request);
            return response.payload || [];
        });
    }
    downloadCsv(projectId, catalogId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/catalogs/${catalogId}/brands/export`;
            return this.executeRaw('post', url, request);
        });
    }
}
exports.BrandClient = BrandClient;
//# sourceMappingURL=brand.client.js.map